import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import CategoryPageLayout from '@99designs/acquisition-frontend/acquisition/components/CategoryPage';
import CategoryConfigProvider from '@99designs/acquisition-frontend/acquisition/components/CategoryPage/CategoryConfigProvider';
import { SiteContext } from '@99designs/acquisition-frontend/shared/lib/site';
import { Site } from '@99designs/site-navigation/lib/Site';
import DefaultPageLayout from '../components/common/DefaultPageLayout';
import { getDefaultPageProps } from '../lib/getDefaultPageProps';
import { DAY_IN_SECONDS, HOUR_IN_SECONDS } from '../lib/time';
import type { SiteConfig } from '@99designs/site-navigation/lib/Site';

export default function CategoryPage({
    siteConfig,
    randomFeaturedDesignerNumber = 0,
    categoryKey,
    userRole,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const site = new Site(JSON.parse(siteConfig) as SiteConfig);

    return (
        <DefaultPageLayout role={userRole} site={site}>
            <SiteContext.Provider value={site}>
                <CategoryConfigProvider
                    language={site.getLanguageCode()}
                    categoryKey={categoryKey}
                    render={(category) => (
                        <CategoryPageLayout
                            site={site}
                            randomFeaturedDesignerNumber={randomFeaturedDesignerNumber}
                            category={category}
                        />
                    )}
                />
            </SiteContext.Provider>
        </DefaultPageLayout>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const defaultProps = await getDefaultPageProps(context);

    context.res.setHeader('Surrogate-Key', 'logo-website-squarespace-landing');
    context.res.setHeader(
        'Surrogate-Control',
        `max-age=${DAY_IN_SECONDS}, stale-while-revalidate=${HOUR_IN_SECONDS}`
    );

    return {
        props: {
            ...defaultProps,
            categoryKey: 'logo-website-squarespace',
            randomFeaturedDesignerNumber: Math.random(),
        },
    };
};
